import {HttpClient, HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';
import {switchMap} from 'rxjs';
import {environment} from '../environments/environment';

// The token cookie belongs to the API origin; read it through CORS rather than document.cookie.
export const csrfInterceptor: HttpInterceptorFn = (request, next) => {
  const api = new URL(environment.apiUrl || '/api', window.location.origin);
  const target = new URL(request.url, window.location.origin);
  const unsafe = !['GET', 'HEAD', 'OPTIONS', 'TRACE'].includes(request.method);
  if (!unsafe || target.origin !== api.origin || !target.pathname.startsWith(api.pathname.replace(/\/$/, '') + '/')
      || request.headers.get('Authorization')?.startsWith('Bearer ') || target.pathname.startsWith('/api/tts/player/')) {
    return next(request);
  }
  const http = inject(HttpClient);
  return http.get<{headerName: string; token: string}>(`${api.origin}/api/csrf`, {withCredentials: true})
    .pipe(switchMap(token => next(request.clone({setHeaders: {[token.headerName]: token.token}}))));
};
